import { createApp } from "vue";
import App from "./App.vue";
import setupPlugins from "@/plugins";

// 本地SVG图标
import "virtual:svg-icons-register";

// 样式
import "element-plus/theme-chalk/dark/css-vars.css";
import "@/styles/core/index.scss";
import "uno.css";
import "animate.css";

// 存储请求取消函数的全局数组（与 axios 拦截器中的 window.axiosCancelTokens 配套）
window.axiosCancelTokens = [];

const app = createApp(App);
app.use(setupPlugins);
app.mount("#app");
